import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  labelControlWrap: {
    '& div': {
      maxWidth: '100%',
    },
  },
}));
